import type { ResidentReportModel } from "../types/resident-report.types";

export function MonthlyActivityChart({
  activityByMonth,
  activitySummary,
}: Pick<ResidentReportModel, "activityByMonth" | "activitySummary">) {
  const maximum = Math.max(1, ...activityByMonth.map((activity) => activity.eventsAttended));

  return (
    <section className="report-card monthly-activity">
      <header>
        <div>
          <p className="report-eyebrow">Attendance</p>
          <h2>Activity by month</h2>
        </div>
        <span>Events attended · Last 12 months</span>
      </header>
      {activityByMonth.length === 0 ? (
        <p className="report-empty-state">No monthly attendance data available.</p>
      ) : (
        <div className="monthly-activity__bars" aria-label="Events attended by month">
          {activityByMonth.map((activity, index) => (
            <div key={activity.month}>
              <strong>{activity.eventsAttended}</strong>
              <span
                className={index === activityByMonth.length - 1 ? "is-current" : ""}
                style={{ height: `${Math.max(8, (activity.eventsAttended / maximum) * 100)}%` }}
              />
              <small>{activity.month}</small>
            </div>
          ))}
        </div>
      )}
      {activitySummary ? <p className="monthly-activity__summary">{activitySummary}</p> : null}
    </section>
  );
}
